import { render, staticRenderFns } from "./BdMain.vue?vue&type=template&id=11c5a374&scoped=true&"
import script from "./BdMain.vue?vue&type=script&lang=js&"
export * from "./BdMain.vue?vue&type=script&lang=js&"
import style0 from "./BdMain.vue?vue&type=style&index=0&id=11c5a374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5a374",
  null
  
)

export default component.exports